export default __webpack_public_path__ + "static/media/manage-your-home.24054450.png";